export default __webpack_public_path__ + "static/media/pay_closed.f4c6c39d.svg";